import { useEffect, useState } from 'react';

/**
 * navigator.onLine is a reasonably reliable "is there a link-layer
 * connection" signal, though not a guarantee of actual internet reachability
 * (e.g. connected to exhibition Wi-Fi with no upstream). The sync engine
 * (Stage 9) additionally treats failed upload attempts as an online/offline
 * signal for that reason -- this hook drives the UI's offline indicator,
 * which errs toward the browser's own signal for responsiveness.
 */
export function useOnlineStatus(): boolean {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
}
